import { memo } from 'react';

import type { ContentBlock } from '@/types/newsService';
import { MarkdownText } from './MarkdownText';

interface Props {
  block: ContentBlock;
}

export const ParagraphBlock = memo(function ParagraphBlock({ block }: Props) {
  if (!block.text) return null;
  return (
    <p className="mb-1 whitespace-pre-line text-base leading-6 text-fg">
      <MarkdownText>{block.text}</MarkdownText>
    </p>
  );
});
